"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGuideLinkContext = exports.GuideLinkProvider = void 0;
const react_1 = __importStar(require("react"));
const defaultContextValue = {
    onOpenLink: ({ base = '', slug, step = '' }) => {
        const { protocol, host } = window.location;
        const url = `${protocol}//${host}${base}${slug}#${step}`;
        console.info(url);
        window.open(url, '_blank');
    },
};
const Context = react_1.createContext(defaultContextValue);
function GuideLinkProvider({ children, onOpenLink }) {
    const contextValue = react_1.useMemo(() => ({ onOpenLink }), [onOpenLink]);
    return react_1.default.createElement(Context.Provider, { value: contextValue }, children);
}
exports.GuideLinkProvider = GuideLinkProvider;
function useGuideLinkContext() {
    return react_1.useContext(Context);
}
exports.useGuideLinkContext = useGuideLinkContext;
